import { render, staticRenderFns } from "./data-view-card.vue?vue&type=template&id=19a26e32&scoped=true&"
import script from "./data-view-card.vue?vue&type=script&lang=js&"
export * from "./data-view-card.vue?vue&type=script&lang=js&"
import style0 from "./data-view-card.vue?vue&type=style&index=0&id=19a26e32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a26e32",
  null
  
)

export default component.exports